module.exports = __webpack_public_path__ + "src/assets/img/10.895afb78.svg";